import { isEqual } from 'lodash';
import { InventoryLevelsResponse } from '@tiendanube/common';
import { InventoryLevelsInterface } from '../../pages/components/Variants/types';

export const generateInventoryLevelsPayload = (
  originalInventoryLevels: InventoryLevelsInterface[] | undefined,
  newInventoryLevels: InventoryLevelsResponse[] | undefined,
): { inventory_levels: InventoryLevelsResponse[] } | undefined => {
  if (!newInventoryLevels) return undefined;
  if (isEqual(originalInventoryLevels, newInventoryLevels)) return undefined;
  const inventoryLevels = newInventoryLevels.map((level) => ({
    location_id: level.location_id,
    stock: level.stock,
  }));
  return {
    inventory_levels: inventoryLevels,
  };
};
